import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";

function PaymentSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
const [deleted, setDeleted] = useState(false);    
  const [checking, setChecking] = useState(true);
  const [paid, setPaid] = useState(false);

  const state = location.state || {};
  const payment = state.payment || {};
  const notificationId =searchParams.get("notification_id") ||location.state?.notificationId ||null;
  const orderId =
    searchParams.get("order_id") ||
    payment.order_id ||
    payment.razorpay_order_id ||
    state.order_id ||
    "";

  const paymentId =
    searchParams.get("razorpay_payment_id") ||
    payment.payment_id ||
    payment.razorpay_payment_id ||
    state.payment_id ||
    "";

  useEffect(() => {
    if (!orderId) {
      setChecking(false);
      return;
    }

    let retryCount = 0;
    const maxRetries = 10;

    const checkPayment = async () => {
      try {
        const res = await axiosInstance.get(`/order/${orderId}/`);
        console.log("PAYMENT SUCCESS CHECK:", res.data);
   console.log("ORDER ID FROM QUERY:", searchParams.get("order_id"));
console.log("FINAL ORDER ID:", orderId);
        if (res.data.payment_status === "paid") {
          setPaid(true);
          setChecking(false);
          if (notificationId && !deleted) {
  try {
    await axiosInstance.delete(`/notifications/${notificationId}/`);
    console.log("✅ Notification deleted after payment");
    setDeleted(true);
  } catch (err) {
    console.log("❌ Failed to delete notification", err);
  }
}    
          setTimeout(() => {
            navigate("/orders", { replace: true });
          }, 1500);
        } else {
          retryCount += 1;
          if (retryCount < maxRetries) {
            setTimeout(checkPayment, 2000);
          } else {
            setChecking(false);
          }
        }
      } catch (err) {
        console.error("Payment status check failed:", err);
        retryCount += 1;
        if (retryCount < maxRetries) {
          setTimeout(checkPayment, 2000);
        } else {
          setChecking(false);
        }
      }
    };

    checkPayment();
}, [orderId, navigate, notificationId]);

  if (!orderId) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h2 style={styles.title}>Payment info not found ❌</h2>
          <button style={styles.button} onClick={() => navigate("/orders")}>
            Go to Orders
          </button>
        </div>
      </div>
    );
  }

  if (checking) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>Processing Payment...</h1>
          <p>Please wait while we confirm your payment.</p>
        </div>
      </div>
    );
  }

  if (paid) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>🎉 Payment Successful!</h1>
          <p><strong>Order ID:</strong> {orderId}</p>
          <p><strong>Payment ID:</strong> {paymentId || "—"}</p>
          <p><strong>Status:</strong> paid</p>

          <button style={styles.button} onClick={() => navigate("/orders", { replace: true })}>
            Go to Orders
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Payment status still pending</h2>
        <button style={styles.button} onClick={() => navigate("/orders", { replace: true })}>
          Go to Orders
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    background: "#e9f7ef",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    background: "#fff",
    padding: "30px 40px",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    textAlign: "center",
    width: "420px",
  },
  title: {
    marginBottom: "20px",
    color: "green",
  },
  button: {
    marginTop: "20px",
    background: "green",
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    color: "white",
    cursor: "pointer",
    fontSize: "16px",
  },
};

export default PaymentSuccess;
